// @ts-nocheck
/* eslint-disable */

// THIS IS AN AUTOGENERATED FILE
import * as React from 'react';
import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import { memo } from 'react';

const SvgTogglePolygonFill = (props: SvgIconProps) => {
	const { sx, ...other } = props;
	return (
		<SvgIcon
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			shapeRendering='geometricPrecision'
			textRendering='geometricPrecision'
			preserveAspectRatio='xMidYMid meet'
			sx={{ ...sx, padding: '0px' }}
			{...other}
		>
			<path d='M16.575 16.227c.355-.695.556-1.48.556-2.31 0-3.4-5.111-8.944-5.111-8.944S10.467 6.652 9.078 8.72l7.497 7.507Z' />
			<path d='M2 2v20h20.029-20V2v20h20l-5.425-5.829q-2.312 2.856-4.584 2.856C9.748 19.027 7.808 18 6.918 15q-.889-3 0 0-.742-2.56 2.184-6.28L2.03 2' />
			<rect width={1} height={22} rx={0} ry={0} transform='matrix(1 0 0 .95497 1 2)' />
			<rect width={20} height={1} rx={0} ry={0} transform='translate(2.029 22)' />
			<rect width={2} height={20} rx={0} ry={0} transform='translate(21 1)' />
			<rect width={22} height={2} rx={0} ry={0} transform='matrix(.81818 0 0 1 3 1)' />
			<path d='M3 1H1v1h1l1 1V1M23 21h-2l1.029 1v1l.971.01V21Z' />
		</SvgIcon>
	);
};

const Memo = memo(SvgTogglePolygonFill) as any as () => JSX.Element;
export default Memo;
